import { round2 } from "@/lib/shopify/economics-helpers"
import type { ConfigEconomicsItem } from "./types"

/** Where a row's COGS figure comes from, in the terms the UI explains. */
export type CogsDisplaySource = "manual" | "catalogProduct" | "shopify" | "mixed" | "partial" | "default" | "none"

export function rowCogsSource(
  row: Pick<ConfigEconomicsItem, "cogs_source" | "cogs_edit" | "units_sold" | "units_with_cogs">,
  hasPendingEdit: boolean,
  defaultCogsPerUnit: number,
): CogsDisplaySource {
  if (hasPendingEdit) return "manual"
  switch (row.cogs_source) {
    case "manual_variant":
      return "manual"
    case "manual_product":
      // This SKU's own product cost, or one the product's other SKUs share.
      return row.cogs_edit?.own.some((o) => o.variant_id == null) ? "manual" : "catalogProduct"
    case "shopify":
      return "shopify"
    case "mixed":
      return row.units_with_cogs < row.units_sold && defaultCogsPerUnit <= 0 ? "partial" : "mixed"
    case "unset":
      return defaultCogsPerUnit > 0 ? "default" : "none"
  }
}

/** One source when every member agrees; otherwise mixed, or partial while some units have no cost. */
export function setCogsSource(memberSources: ReadonlyArray<CogsDisplaySource>): CogsDisplaySource {
  if (new Set(memberSources).size === 1) return memberSources[0]
  return memberSources.some((s) => s === "partial" || s === "none") ? "partial" : "mixed"
}

/** Editor text for a per-unit cost: cents, without float noise like 0.10000000000000002. */
export function cogsInputValue(perUnit: number | null): string {
  return perUnit == null ? "" : String(round2(perUnit))
}
